import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import { useUser } from '../contexts/UserContext';
function Modal({ message, onClose }) {
   const handleOverlayClick = (e) => {
      if (e.target.className === 'modal_overlay') {
         onClose();
      }
   };
   return (
      <div className="modal_overlay" onClick={handleOverlayClick}>
         <div className="modal_content">
            <div className="modal_content_header">
               <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            <div className="modal_content_body d-flex flex-column">
               <p>{message}</p>
               <span onClick={onClose} className="ppt_btn_primary ms-auto alt">Accept</span>
            </div>
         </div>
      </div>
   );
}
function SignIn() {
   const { login, isAuthenticated, isLoading } = useUser();
   const [showModal, setShowModal] = useState(false);
   const [modalMessage, setModalMessage] = useState('');
   const [email, setEmail] = useState('');
   const [password, setPassword] = useState('');
   const navigate = useNavigate();
   useEffect(() => {
      localStorage.clear();
   }, []);
   useEffect(() => {
      if (isAuthenticated && !isLoading) {
         navigate('/dashboard', { replace: true });
      }
   }, [isAuthenticated, isLoading, navigate]);
   const handleSubmit = async (e) => {
      e.preventDefault();
      if (!email || !password) {
         setModalMessage('Please enter your email and password');
         setShowModal(true);
         return;
      }
      try {
         const result = await login(email, password);
         if (result.success) {
            navigate('/dashboard');
         } else {
            // Traducir mensajes de error específicos o usar un mensaje predeterminado en inglés
            let errorMessage = 'Invalid credentials';
            // Si hay un mensaje del resultado, verificar si está en español y traducirlo
            if (result.message) {
               if (result.message.includes('Credenciales inválidas')) {
                  errorMessage = 'Invalid credentials';
               } else if (result.message.includes('correo electrónico')) {
                  errorMessage = 'Please enter a valid email';
               } else if (result.message.includes('contraseña')) {
                  errorMessage = 'Please enter a valid password';
               } else {
                  // Para otros mensajes que no reconocemos, usamos el mensaje genérico
                  errorMessage = 'Authentication error. Please try again.';
               }
            }
            setModalMessage(errorMessage);
            setShowModal(true);
         }
      } catch (err) {
         console.error('Error in fetch:', err);
         setModalMessage('Connection error. Please try again.');
         setShowModal(true);
      }
   };
   if (isLoading) {
      return <div>Loading...</div>;
   }
   return (
      <>
         {showModal && (
            <Modal
               message={modalMessage}
               onClose={() => setShowModal(false)}
            />
         )}
         <div className="container" page-key="signin">
            <div className="row">
               <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
                  <span className="mt-auto d-lg-none">
                     <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
                  </span>
                  <DarkModeBtn />
               </div>
               <div className="col-12">
                  <nav className="ppt_log mb-4 mb-lg-5">
                     <NavLink to="/sign-in">Sign In</NavLink>
                     <NavLink to="/sign-up">Sign Up</NavLink>
                  </nav>
                  <form className="ppt_form signIn" onSubmit={handleSubmit}>
                     <h3 className="ppt_form_title mb-5">Sign In</h3>
                     <div className="ppt_input_style mb-4">
                        <label>Email</label>
                        <div><input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
                     </div>
                     <div className="ppt_input_style mb-4">
                        <label>Password</label>
                        <div><input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
                     </div>
                     <div className="ppt_input_style mb-3 mb-lg-5">
                        <button type="submit" className="ppt_btn_primary">Next</button>
                     </div>
                     <div className="ppt_gen_msg">
                        <p className="mb-0">
                           If you are looking to recover your individual wallet, click {' '}
                           <NavLink to="/recovery-phrase">here</NavLink> to use your recovery phrase.
                        </p>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </>
   );
}
export default SignIn;